import React from "react";
import { PhoneIcon } from "lucide-react";
import { team } from "../../data/home";
export function Team() {
  return <section id="equipe" className="scroll-mt-24 bg-surface px-5 py-20 md:px-8 md:py-32" data-id="element-186" data-mp="3dqgomphuck4i">
      <div className="mx-auto max-w-7xl" data-id="element-187" data-mp="3irw9ohk0qqmw">
        <div className="max-w-2xl" data-id="element-188" data-mp="3iorw4tknyijk">
          <p className="text-[15px] font-medium text-muted" data-id="element-189" data-mp="3nqhaai36ncbv">Notre équipe</p>
          <h2 className="mt-3 text-4xl font-semibold leading-[1.05] tracking-tightest md:text-6xl" data-id="element-190" data-mp="2q278a33ecokr">
            Des experts issus de la banque d’investissement.
          </h2>
        </div>

        <div className="mt-14 grid gap-10 md:grid-cols-2 md:gap-8" data-id="element-191" data-mp="2uyxm0jrqb830">
          {team.map(member => <article key={member.name} className="flex flex-col" data-id="element-192" data-mp="2zyk354aoh8h3">
              <div className="overflow-hidden rounded-[28px] bg-line" data-id="element-193" data-mp="34so7dfsk72eh">
                <img src={member.image} alt={`Portrait de ${member.name}`} className="aspect-[4/3] w-full object-cover object-top" data-id="element-194" data-mp="27chb59c5vqpo" />
              </div>
              <div className="flex flex-1 flex-col pt-7" data-id="element-195" data-mp="15pe42oyvlmv5">
                <h3 className="text-2xl font-semibold tracking-tight md:text-3xl" data-id="element-196" data-mp="10qaxh038z8l2">{member.name}</h3>
                <p className="mt-1 text-[15px] font-medium text-ink/70" data-id="element-197" data-mp="vzkqxjj34zos">{member.role}</p>
                <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-198" data-mp="ryr30q5n7kvw">{member.bio}</p>
                <a href={`tel:${member.phone.replace(/\s/g, "")}`} className="mt-auto flex w-fit items-center gap-2 pt-6 text-[15px] font-medium underline-offset-4 hover:underline" data-id="element-199" data-mp="mzejofdzcvy2">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-200" data-mp="d29ue6ou8kd1" />
                  {member.phone}
                </a>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}